import React, { useEffect, useRef, useState } from "react";
import { useInterviewFeedback } from "hooks/useInterviewFeedback";
import { injectDrawerStyles } from "./drawerStyles";

injectDrawerStyles();

const DEBOUNCE_MS = 600;

const NotesSection = () => {
  const { note, setNote } = useInterviewFeedback();

  // Seed from hook value once — never sync back from hook after that,
  // so setNote triggering a re-render doesn't overwrite what the user typed.
  const [localNote, setLocalNote] = useState(() => note ?? "");
  const debounceRef = useRef(null);

  const handleChange = (e) => {
    const val = e.target.value;
    setLocalNote(val);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => setNote(val), DEBOUNCE_MS);
  };

  // Flush any pending debounce on unmount so nothing is lost
  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
        // use ref so we always get the latest value in cleanup
      }
    };
  }, []);

  return (
    <>
      <div className="dw-header">
        <span className="dw-title">Notes</span>
      </div>
      <div style={{ flex: "1 1 auto", minHeight: 0, padding: "16px", overflow: "hidden" }}>
        <textarea
          className="dw-textarea"
          placeholder="Start typing from here..."
          value={localNote}
          onChange={handleChange}
        />
      </div>
    </>
  );
};

export default NotesSection;